const Career = () => {
	return (
		<>
			<h1 className="display-3 mb-4">Career</h1>
			<p></p>
			
		</>
	)
}
export default Career